<template>
  <div class="container">
    <div class="goBackBtn" @click="$router.go(-1) & closeGA4Click('click', 'cerrar', 'terminos y condiciones')">
      <h2>
        X
      </h2>
    </div>
    <div id="tycos" class="terms" v-html="tycos"></div>
  </div>

</template>

<script>
import Axios from "axios";
import tagFunctions from '@/utils/tagFunctions.js'

export default {
  name: "Tycos",
  props: {
    name: {
      type: String,
      default: "cuamoc.com.mx"
    },
  },
   data() {
    return {
      tycos: ""
    };
  },
  async mounted() {
    window.scrollTo(0,0)
    tagFunctions.user_interactionPush('view', 'terminos y condiciones', 'footer');
  try {
    const response = await Axios.get('https://api-mx-marketing.azure-api.net/sitios/tycos', {
      headers: {
        'campaign' : 'general'
      }
    });
    this.tycos = response.data
    .replace('{', '').replace('"body":"', '').replace(`";
        }`,'').replace("[[urlsitio]]", "https://indio.com.mx/")
    } catch (error) {
      //console.error(error);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.container {
  background-image: url("/Back-2.png");
  background-position: center;
  background-size: 104%;
}

.goBackBtn {
  display: flex;
  flex-direction: row;
  //width: 130px;
  width: 70px;
  background-color: transparent;
  border: none;
  color: $green-pantone-7729c;
  font-family: $font-dinbold;
  //margin-left: 2rem;
  font-size: 1.4vw;
  float: right;
  position: absolute;
  top: 0px;
  right: 0px;
  h2 {
    color: $green-pantone-7729c !important;
    margin-inline: 0;
  }
  @media screen and (max-width: 768px) {
    //width: 80px;
    width: 42px;
    h2 {
      font-size: 4.8vw;
    }
  }
}
.goBackBtn:hover {
  cursor: pointer;
}

.terms {
  padding-inline: 2vw;
  font-family: "Wood-Bonnet-Grotesque" !important;
  font-size: 1.7vw !important;
  margin-right: 16.2pt !important;
  margin-left: 16.2pt !important;
  color: $green-pantone-7729c !important;
  padding-bottom: 2vw;
  padding-top: 6vw !important;
  text-align: justify;
  h3,
  p {
    margin: 0;
    margin-bottom: 0pt !important;
  }
  @media (max-width: 768px) {
    font-size: 5.5vw !important;
    margin-right: 10.2pt !important;
    margin-left: 10.2pt !important;
    padding-top: 14vw !important;
    padding-bottom: 0vw;
  }
}
</style>
<style lang="scss">
.terms h1, h2 {
  font-size: 1.7vw;
  @media (max-width: 768px) {
    font-size: 5.5vw;
  }
}
</style>